import { Dialog } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { PortfolioRateGroupOverview } from '@mews-commander/data-access';

interface Props {
    rateGroups: PortfolioRateGroupOverview[];
    isLoading: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

export const DeleteLocalRateGroupDialog = ({ rateGroups, isLoading, onConfirm, onCancel }: Props) => (
    <Dialog
        title={
            <LocalizedText
                textKey={TextKey.LocalRateGroupDeleteDialogTitle}
                substitutes={{ count: rateGroups.length }}
            />
        }
        actions={[
            {
                children: <LocalizedText textKey={TextKey.Cancel} />,
                onClick: onCancel,
                variant: 'tertiary',
                size: 'medium',
                type: 'button',
            },
            {
                children: <LocalizedText textKey={TextKey.Delete} />,
                onClick: onConfirm,
                variant: 'destructive',
                size: 'medium',
                type: 'submit',
            },
        ]}
        active
        loading={isLoading}
        onClose={onCancel}
    >
        <LocalizedText
            textKey={TextKey.LocalRateGroupDeleteDialogDescription}
            substitutes={{
                rateGroupName: rateGroups[0]?.name,
                propertyName: rateGroups[0]?.property,
                count: rateGroups.length,
            }}
        />
    </Dialog>
);
